import { render, staticRenderFns } from "./OGWhatsApp.vue?vue&type=template&id=7d491e27&scoped=true"
import script from "./OGWhatsApp.vue?vue&type=script&lang=js"
export * from "./OGWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./OGWhatsApp.vue?vue&type=style&index=0&id=7d491e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d491e27",
  null
  
)

export default component.exports